import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { apiService } from '../../services/api';
import { useToast } from '../../hooks/use-toast';
import { HandHelping, Save, RefreshCw } from 'lucide-react';

const CONTACT_CONFIG_TYPE = 'hubungi_kami';

const DEFAULT_CONTACT_SETTINGS = {
  title: 'Ingin Bergabung dengan IJSL?',
  description: 'Daftarkan tim Anda sekarang dan jadilah bagian dari kompetisi sepak bola junior terbaik di Indonesia!',
  button_text: 'Hubungi Kami',
  button_link: 'https://wa.me/6281234567890',
  email: 'admin@ijsl.co.id',
  phone: '+62 812-3456-7890',
  whatsapp: '+62 812-3456-7890',
  address: 'Jakarta, Indonesia',
};

const AdminContactSettings = () => {
  const [form, setForm] = useState(DEFAULT_CONTACT_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const loadContactSettings = async () => {
    setLoading(true);
    try {
      const response = await apiService.admin.getAppConfig();
      const values = response?.data?.[CONTACT_CONFIG_TYPE];
      if (Array.isArray(values) && values[0] && typeof values[0] === 'object') {
        setForm({ ...DEFAULT_CONTACT_SETTINGS, ...values[0] });
      } else {
        setForm(DEFAULT_CONTACT_SETTINGS);
      }
    } catch (error) {
      toast({ title: 'Info', description: 'Menggunakan nilai default Hubungi Kami', variant: 'default' });
      setForm(DEFAULT_CONTACT_SETTINGS);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadContactSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await apiService.admin.updateAppConfig(CONTACT_CONFIG_TYPE, [form]);
      toast({ title: 'Berhasil', description: 'Konten Hubungi Kami berhasil disimpan' });
    } catch (error) {
      toast({ title: 'Error', description: 'Gagal menyimpan konten Hubungi Kami', variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-4xl space-y-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <HandHelping className="h-8 w-8 text-green-600" />
              <div>
                <h2 className="text-2xl font-bold text-gray-900">Hubungi Kami</h2>
                <p className="text-gray-600">Atur konten kontak yang ditampilkan di halaman Tentang Kami</p>
              </div>
            </div>
            <button
              type="button"
              onClick={loadContactSettings}
              className="inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-gray-50"
            >
              <RefreshCw className="h-4 w-4" />
              Refresh
            </button>
          </div>
        </div>

        {loading ? (
          <div className="bg-white rounded-lg shadow-md p-6 text-gray-500">Memuat pengaturan Hubungi Kami...</div>
        ) : (
          <form onSubmit={handleSave} className="bg-white rounded-lg shadow-md p-6 space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Judul</label>
              <input
                type="text"
                name="title"
                value={form.title}
                onChange={handleChange}
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Deskripsi</label>
              <textarea
                name="description"
                value={form.description}
                onChange={handleChange}
                rows={4}
                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                required
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Teks Tombol</label>
                <input
                  type="text"
                  name="button_text"
                  value={form.button_text}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Link Tombol</label>
                <input
                  type="url"
                  name="button_link"
                  value={form.button_link}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                  placeholder="https://wa.me/..."
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input
                  type="text"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Telepon</label>
                <input
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">WhatsApp</label>
                <input
                  type="text"
                  name="whatsapp"
                  value={form.whatsapp}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Alamat</label>
                <input
                  type="text"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-green-500"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={saving}
              className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 font-semibold text-white transition hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <Save className="h-4 w-4" />
              {saving ? 'Menyimpan...' : 'Simpan Perubahan'}
            </button>
          </form>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminContactSettings;